import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { ISpecialHandlingCode } from '../../model/special-handling-code.model';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class SpecialHandlingCodeService {
  async getSpecialHandlingCodes(): Promise<ISpecialHandlingCode[]> {
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.SpecialHandlingCode.SpecialHandlingCodes,
      {},
    );
  }

  async getSpecialHandlingCode(code: string): Promise<ISpecialHandlingCode> {
    const url =
      API_CORE.URLs.SpecialHandlingCode.SpecialHandlingCodeByCode.replace(
        '{code}',
        code,
      );
    return CaiApi.get(API_CORE.name, url, {});
  }
}
